<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
     <div class='goods-grid'>
      <dx-data-grid ref='refInventoryGrid'
        :data-source='rawMaterialInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        key-expr="품번"
        @cell-prepared='onCellPrepared'
        @toolbar-preparing='onToolbarPreparing'
        @row-updated='onRowUpdated' @row-updating="onRowUpdating"
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="stockTitle"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="false"
          :allow-updating="true"
          :allow-adding="false"
          :use-icons="true"
          mode='batch'
        >
        </DxEditing>
        <DxColumn v-if="$store.getters.getGroupName !== null"
          :allowEditing='false'
          :caption="$store.getters.getGroupName"
          data-field="차종"
          sort-order='asc'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품번"
          data-field="품번"
          sort-order='asc'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품명"
          data-field="품명"
          :visible='true'
        >
        </DxColumn>
        <DxColumn v-if="isPurchaseType"
          :allowEditing='false'
          caption="구매처"
          data-field="거래처코드"
          :visible='true'
        >
          <DxLookup
            :data-source="companyInfoLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn v-if="isPurchaseType"
          :allowEditing='false'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="단위"
          data-field="단위"
          :visible='true'
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="창고이월재고"
          data-field="창고재고"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="창고재고보정"
          data-field="창고재고보정"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <!-- <DxColumn v-if="isPurchaseType"
          :allowEditing='false'
          caption="금월입고"
          data-field="불출수량"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="금월출고/출하"
          data-field="출하수량"
          :visible='true'
          format='#,##0'
        />
        <DxColumn  v-if="isPurchaseType"
          :allowEditing='false'
          caption="불량반품"
          data-field="불량반품"
          :calculate-cell-value="calcBedReturnAmount"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn  v-if="!isPurchaseType"
          :allowEditing='false'
          caption="불량폐기"
          data-field="불량폐기"
          :calculate-cell-value="calcBedDiscardAmount"
          :visible='true'
          format='#,##0'
          dataType="number"
        /> -->
        <DxColumn
          :allowEditing='false'
          caption="이월재공"
          data-field="재공재고"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="재공보정"
          data-field="재공재고보정"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          caption="재고현황"
          alignment='center'
        >
          <DxColumn
            :allowEditing="$store.getters.getSysParamByKey('창고관리') !== 'false'"
            caption="창고현재고"
            data-field="현창고재고"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
          <DxColumn
            :allowEditing='true'
            caption="현재재공"
            data-field="현재공"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
          <DxColumn
            :allowEditing='true'
            caption="합계"
            :calculate-cell-value="calculateStcokAmount"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
        </DxColumn>
        <!-- <DxColumn
          caption="재고수정"
          width="70"
          :buttons="editButtons"
          type="buttons"
        /> -->
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="품번"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->

</template>

<script>
import Loading from 'vue-loading-overlay'
import AppLib from '../../../share/AppLib'
import ConstDef from '../../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxTotalItem, DxEditing,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup } from 'devextreme-vue/data-grid'

export default {
  name: 'CurrentStockAdjustTemp',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      rawMaterialInfoList: null,
      stockTitle: null,
      meterialTypeLookup: null,
      unitLookup: null,
      editButtons: ['edit'],
      adjustDate: null,
      adjustWidget: null,
      companyInfoLookup: null
    }
  },
  props: {
    goodsOption: {
      type: String,
      default: null
    },
    goodsType: {
      type: String,
      default: null
    }
  },
  computed: {
    isPurchaseType () {
      return this.goodsOption === ConstDef.구매품
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxEditing,
    DxLookup
  },
  created () {
    console.log('CurrentStockAdjustTemp created')
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.adjustDate = `${AppLib.getToday()} ${this.$store.getters.getSysParamByKey('재고관리기준시간')}`
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.companyInfoLookup = this.$store.getters.getPartnersInfo
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.refreshCurrentStock(this.adjustDate)
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
    this.$snotify.info('재고 조정 후에는 새로고침 하여 주세요')
  },
  updated () {
  },
  beforeDestroy: function () {
  },
  methods: {
    calcBedDiscardAmount (row) {
      return row.반송폐기수량 + row.불량폐기수량
    },
    calcBedReturnAmount (row) {
      return row.반송반품수량 + row.불량반품수량
    },
    calculateStcokAmount (row) {
      return row.현창고재고 + row.현재공
    },
    onCellPrepared (e) {
      if (e.rowType === 'data' && e.column.caption === '합계') { // 창고재고
        this.$Q(e.cellElement).css('color', 'blue')
      }
      if (e.rowType === 'data' && e.column.caption === '현재재공') { // 창고재고
        this.$Q(e.cellElement).css('color', 'red')
      }
    },
    onRowUpdated (row) {
      console.log(row.data)
      const param = {
        등록일: AppLib.getNow(),
        품번: row.data.품번,
        변경재고: row.data.현창고재고,
        변경재공: row.data.현재공,
        // 재고보정: this.diffStock,
        // 재공보정: this.diffWip,
        userId: this.userInfo.userId
        // 이월일자: `${AppLib.calcMonthFromToday(-1).substring(0, 7)}-01`
      }
      this.$_sp.runUpdateProc('spUpdateInventoryAdjust', [param])
        .then((data) => {
          // 재공재고보정=재공재고보정  + In변경재공  - currentWip,
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdating (row) {
    },
    onToolbarPreparing (e) {
      const baseDate = `${AppLib.calcMonthFromToday(-1).substring(0, 7)}-01`
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>조정 기준일시:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 130,
            value: this.adjustDate,
            type: 'datetime',
            displayFormat: 'yyyy-MM-dd HH:mm',
            onInitialized: (args) => {
              this.adjustWidget = args.component
            },
            onValueChanged: (args) => {
              this.adjustDate = args.value
              console.log(AppLib.formatDateTimeFromTimeStamp(this.adjustDate))
              if (this.checkCurrentMonthOrNotFirstDate(this.adjustDate) < 0) {
                this.$snotify.error('전월 또는 매월 1일 10시 이전에 파악된 재고는 조정할 수 없습니다.')
                this.adjustDate = AppLib.nowTimestamp()
                this.adjustWidget.option({ value: this.adjustDate })
              } else {
                this.refreshCurrentStock(this.adjustDate)
              }
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:blue;'><b>이월기준일: ${baseDate}</b></div>`
          }
        }
      )
    },
    checkCurrentMonthOrNotFirstDate (dateLong) {
      const ivalidDate = `${AppLib.getNow().substring(0, 7)}-01 10:10:00`
      const timeStamp = AppLib.getTimestampFromString(ivalidDate)
      console.log(ivalidDate, dateLong)
      if (dateLong < timeStamp) {
        return -1
      }
      return 0
    },
    refreshCurrentStock (dateLong) {
      this.stockTitle = `${AppLib.getToday()}_${this.goodsType}_재고`
      const param = {
        toDate: AppLib.formatDateTimeFromTimeStamp(dateLong),
        품목유형: this.goodsOption
      }
      console.log(param)
      this.isLoading = true
      let procServioce = this.$_sp.runNoEncodeFindProc('spFindAllStockAdjustByToDateAndPtypeV2', param)
      // if (this.goodsCode === ConstDef.완제품) {
      //   procServioce = this.$_sp.runNoEncodeFindProc('spFindAllStockNotReceiptProductionByToDateV2', param)
      // }
      procServioce
        .then((data) => {
          this.isLoading = false
          this.rawMaterialInfoList = this.$_sp.MakeModel(data)
          console.log(this.rawMaterialInfoList)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
